import {
  SlMenu
} from "./chunk.MQVSSGFY.js";

// src/components/menu/menu.ts
var menu_default = SlMenu;
SlMenu.define("sl-menu");

export {
  menu_default
};
